var _jsxFileName = "/codebuild/output/src2760838910/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/Button/index.tsx";
import React, { memo } from 'react';
import { Button as ButtonParallax } from '@adc/parallax-component-library';
const Button = /*#__PURE__*/memo(({
  testID,
  disabled,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(ButtonParallax, Object.assign({
    testID: disabled ? `${testID}-disabled` : `${testID}`,
    disabled: disabled
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }));
});
Button.displayName = 'Button';
export { Button };